export default "__VITE_ASSET__DNNRAjjr__"